import { object, SchemaOf } from 'yup';
import { validateSubDomain } from 'lib/utils/inputValidation';
import { CreateTeamFields, CreateTeamSchema } from './types';

export const createTeamSchemaValidation: SchemaOf<CreateTeamSchema> = object().shape({
  [CreateTeamFields.subdomain]: validateSubDomain,
});
